(function () {
  const smartScript = window.AF_SMART_SCRIPT;

  if (!smartScript) return;

  const result = smartScript.generateOneLinkURL({
    oneLinkURL: 'https://inku.onelink.me/VC03',
    SEO: true,
    afParameters: {
      mediaSource: {
        keys: ['utm_source'],
        defaultValue: 'website',
      },
      campaign: {
        keys: ['utm_campaign'],
      },
      adSet: {
        keys: ['utm_content'],
      },
      ad: {
        keys: ['utm_term'],
      },
      afCustom: [
        {
          paramKey: 'af_ss_ui',
          defaultValue: 'true',
        },
      ],
    },
  });

  if (!result || !result.clickURL) return;

  document.querySelectorAll('[data-appsflyer-onelink]').forEach((link) => {
    link.href = result.clickURL;
  });
})();
